import React from 'react';
import { HeroSection } from './components/HeroSection';
import { MethodologySection } from './components/MethodologySection';
import { AudienceAndProofSection } from './components/AudienceAndProofSection';
import { OfferSection } from './components/OfferSection';
import { FAQAndClosingSection } from './components/FAQAndClosingSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { WhatsAppButton } from './components/WhatsAppButton';
import { TopOfferBar } from './components/TopOfferBar';
export function App() {
  return <div className="min-h-screen bg-black font-sans selection:bg-yellow-400 selection:text-black antialiased" data-id="element-0">
      <TopOfferBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <MethodologySection data-id="element-3" />
      <AudienceAndProofSection data-id="element-4" />
      <OfferSection data-id="element-5" />
      <FAQAndClosingSection data-id="element-6" />

      <PurchaseNotification data-id="element-7" />
      <WhatsAppButton data-id="element-8" />
    </div>;
}